import { render, staticRenderFns } from "./NewsCards.vue?vue&type=template&id=03445ac6&scoped=true&"
import script from "./NewsCards.vue?vue&type=script&lang=js&"
export * from "./NewsCards.vue?vue&type=script&lang=js&"
import style0 from "./NewsCards.vue?vue&type=style&index=0&id=03445ac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03445ac6",
  null
  
)

export default component.exports